if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}


// WEBPACK FOOTER //
// ./Components/Shared/PolyFills/forEach.js